import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVirtualboxComponent } from './simple-icons-virtualbox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVirtualboxComponent ],
    exports:      [ SimpleIconsVirtualboxComponent ],
    bootstrap:    []
})
export class SimpleIconsVirtualboxModule {}
